import {
  getToken,
  initializeAppCheck,
  ReCaptchaV3Provider
} from 'firebase/app-check'

const appCheckByAppName = new Map()

/**
 * @see https://firebase.google.com/docs/app-check/web/recaptcha-provider
 */
function getRecaptchaSiteKey(region) {
  if (region === 'ca') {
    return (
      import.meta.env.VITE_CA_FIREBASE_APP_CHECK_SITE_KEY ||
      import.meta.env.VITE_FIREBASE_APP_CHECK_SITE_KEY
    )
  }
  return import.meta.env.VITE_FIREBASE_APP_CHECK_SITE_KEY
}

export function initFirebaseAppCheck(app, region = 'us') {
  const existing = appCheckByAppName.get(app.name)
  if (existing) return existing

  const siteKey = getRecaptchaSiteKey(region)
  if (!siteKey) {
    console.warn(
      '[App Check] Missing VITE_FIREBASE_APP_CHECK_SITE_KEY (reCAPTCHA v3 site key from Firebase App Check console).'
    )
    return null
  }

  if (import.meta.env.DEV) {
    console.info(
      '[App Check] Initializing',
      region,
      'project',
      app.options.projectId,
      'appId',
      app.options.appId
    )
  }

  const instance = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(siteKey),
    isTokenAutoRefreshEnabled: true
  })
  appCheckByAppName.set(app.name, instance)
  return instance
}

export async function waitForAppCheckToken(app) {
  if (!app) return

  const appCheck = appCheckByAppName.get(app.name)
  if (!appCheck) return

  try {
    await getToken(appCheck, false)
  } catch {
    // App Check may be unavailable (missing site key) — Firestore read may still retry.
  }
}
